export default __webpack_public_path__ + "locales/sr-Latn-RS/Ldap.json?hash=d3acf48226c2a23243962ef7d8c9b443";